const styles = {
  itemDescription: {
    width: '200px',
    marginTop: 1.5,
  },
  gridlist: {
    p: 2,
    mr: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
  },
  gridContainer: {
    mb: 6,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },

}

export default styles
